<template>
  <div class="featured-hero" :style="backgroundStyle">
    <div class="featured-hero__content">
      <div class="featured-hero__pass-header">
        <Passes
          :passName="selection"
          :size="72"
          class="featured-hero__pass-badge"
        />
        <h6 class="featured-hero__pass-title">{{ selection }}</h6>
      </div>
      <div class="featured-hero__pass-description">
        {{ path.description }}
      </div>
      <div class="featured-hero__pass-features">
        <div
          class="featured-hero__pass-features-item"
          v-for="featureDetails in features.details"
          :key="featureDetails"
        >
          <CheckIcon />
          <span class="featured-hero__pass-features-item-text">
            {{ featureDetails }}
          </span>
        </div>
      </div>
      <div class="featured-hero__pass-details">
        <LearningPathDetails :pathId="path.objectID" :title="selection" />
      </div>
      <div class="featured-hero__actions">
        <router-link
          :to="$buildContentLink('path', path)"
          class="btn btn--primary"
          >Get Started
        </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import Passes from '@/components/properties/Passes.vue'
import CheckIconSvg from '@/assets/icons/starter-pass/check-green.svg'
import LearningPathDetails from '@/components/home/starter-pass-view/LearningPathDetails.vue'

export default {
  name: 'FeaturedHero',
  components: {
    Passes,
    LearningPathDetails,
    CheckIcon: { ...CheckIconSvg, name: 'CheckIcon' },
  },
  props: {
    selection: {
      type: String,
      required: true,
    },
    path: {
      type: Object,
      required: true,
    },
  },
  computed: {
    features() {
      return this.allFeatures.find(feature => feature.name === this.selection)
    },
    backgroundStyle() {
      return `
        background-image: url(${this.$getPlaylistBackground(
          this.path?.objectID
        )});
      `
    },
  },
  data() {
    return {
      allFeatures: [
        {
          name: 'Cyber Security',
          details: [
            'Prepares you for eJPT',
            'Approximate Student Effort: 38h 13m',
            '3 Black Box Practice Pentests',
          ],
        },
        {
          name: 'Data Science',
          details: [
            'Jupyter Notebooks',
            'Programming Exercises',
            'Machine Learning Projects',
          ],
        },
        {
          name: 'Cloud',
          details: [
            'Hands-On Labs To Practice What You Learn',
            'Review Questions To Test Your Understanding',
            'In Depth On-Demand Videos',
          ],
        },
        {
          name: 'Networking',
          details: [
            'In Depth On-Demand Videos',
            'Review Questions To Test Your Understanding',
          ],
        },
      ],
    }
  },
}
</script>

<style lang="scss" scoped>
.featured-hero {
  background-repeat: no-repeat;
  background-position: top;
  background-size: cover;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    top: 0px;
    right: 0px;
    bottom: 0px;
    left: 0px;
    background: linear-gradient(180deg, transparent 90%, var(--dark-gray) 100%);
    @include tablet {
      background: linear-gradient(
        180deg,
        transparent 80%,
        var(--dark-gray) 100%
      );
    }
    @include desktop {
      background: linear-gradient(
        180deg,
        transparent 60%,
        var(--dark-gray) 100%
      );
    }
  }
  @include desktop {
    padding: 100px 0 40px 0;
  }
  &__content {
    padding: 30px 20px;
    color: var(--white);
    @include tablet {
      display: grid;
      grid-template-columns: 70% 30%;
    }
    @include desktop {
      padding: 60px 100px 110px;
      max-width: 1440px;
      margin: auto;
    }
  }
  &__pass {
    &-header {
      @include tablet {
        display: flex;
        align-items: center;
      }
    }
    &-badge {
      margin-bottom: 20px;
      @include tablet {
        margin-bottom: 0;
      }
    }
    &-title {
      margin: 0 0;
      font-family: var(--font-medium);
      font-weight: 700;
      font-size: 32px;
      line-height: 38px;
      @include tablet {
        margin-left: 30px;
      }
      @include desktop {
        font-size: 40px;
      }
    }
    &-description {
      font-weight: 400;
      font-size: 18px;
      line-height: 24px;
      margin: 30px 0;
      @include tablet {
        grid-column: 1 / 2;
        margin: 30px 0 40px;
      }
      @include desktop {
        width: 610px;
      }
    }
    &-features {
      margin-bottom: 60px;
      @include tablet {
        grid-column: 1 / 2;
        margin-bottom: 30px;
      }
      &-item {
        display: flex;
        align-items: center;
        margin-bottom: 10px;
        &:last-of-type {
          margin-bottom: 0;
        }
        svg {
          width: 16px;
        }
        &-text {
          line-height: 20px;
          margin-left: 10px;
        }
      }
    }
    &-details {
      @include tablet {
        grid-column: 2/3;
        grid-row: 1 / 7;
        justify-self: end;
      }
    }
  }
  &__actions {
    a {
      width: 100%;
      @include tablet {
        width: unset;
      }
    }
  }
}
</style>
